import { DarkThemeColors } from './themes'
import { LightThemeColors, LightThemeGradients } from './themes/LightTheme'
import { THEME_HTML_ATTRIBUTE, ThemeColorToken } from './ThemeTokens'

/**
 * @deprecated Use ThemeColors where CSS-variables work, or themes directly (ie LightThemeColors). You can also use getThemeColorValue(token) to get the themed color (only works on web interfaces).
 */
export const WebColors = LightThemeColors

/**
 * @deprecated Use ThemeGradients where CSS-variables work, or themes directly (ie LightThemeGradients).
 */
export const WebGradients = LightThemeGradients

/**
 * Get the color value for a given token using the current theme.
 */
export const getThemeColorValue = (token: ThemeColorToken): string => {
  const theme: Record<ThemeColorToken, string> =
    document.documentElement.getAttribute(THEME_HTML_ATTRIBUTE) === 'dark' ? DarkThemeColors : LightThemeColors
  return theme[token]
}
